module.exports = __webpack_public_path__ + "static/img/img_rrdsncpsydsyz.b913c64.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_rrdsncpsydsyz.png
// module id = Uh9H
// module chunks = 0